//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
/**@type {import('../types').DataType<import('./types').EmailConnectionDataModel>} */

var EMAIL_CONNECTION_DATA_TYPE = {
  data: {
    url: '/backend/emailqueueconnection',
    itemUrl: '/backend/emailqueueconnection?name={id}',
    dataKey: 'emailqueueconnection',
    idKeyProp: 'Name'
  },
  placeholders: {
    label: function label(data) {
      return 'Default Email Connection';
    },
    type: function type() {
      return 'email connection';
    },
    icon: function icon() {
      return 'email';
    }
  },
  columns: [{
    id: 'Name',
    children: 'Name',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.Text, {
        value: data.Name
      });
    }
  }, {
    id: 'SMTPHost',
    children: 'SMTPHost',
    formatter: function formatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(Formatter.Text, {
        value: "".concat(data.SMTPHost, ":").concat(data.SMTPPort)
      });
    }
  }, {
    id: 'SMTPUsername',
    children: 'SMTPUsername',
    formatter: function formatter(_ref3) {
      var data = _ref3.data;
      return React.createElement(Formatter.Text, {
        value: data.SMTPUsername
      });
    }
  }] // contextMenu: [],

};
export default EMAIL_CONNECTION_DATA_TYPE;